import { render } from "./DashboardMedical.vue?vue&type=template&id=35066239"
import script from "./DashboardMedical.vue?vue&type=script&lang=js"
export * from "./DashboardMedical.vue?vue&type=script&lang=js"

import "./DashboardMedical.vue?vue&type=style&index=0&id=35066239&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__